module.exports = __webpack_public_path__ + "img/portrait-035.01cc0b1d.jpg";